import React from "react";

export default function NewlineText(props) {
    return props.text.split('\n').map(str => <p>{str}</p>);
}